import {NavLink} from 'react-router-dom';
import {Button, Typography} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {AppRoutePaths} from 'routing/Routes';
import {CarDto, CustomerDto, ReservationDto} from '../../../../../../PRMGApiClient';
import {DatetimeColumn, DateFilterDropdown} from 'views/serviceActions/utils/ServicesUtils';

const {Text} = Typography;

export const reservationsColumns: ColumnsType<ReservationDto> = [
  {
    title: t('Car'),
    sorter: true,
    key: 'id',
    filterMode: 'tree',
    filterSearch: true,
    render: (reservation: ReservationDto) => (
      <NavLink to={`${AppRoutePaths.reservation.url}/${reservation.id}`}>
        <Button type="link" className="p-0">
          {reservation.car?.carMakeName} {reservation.car?.carModelName}
        </Button>
      </NavLink>
    ),
  },
  {
    title: t('Plate number'),
    dataIndex: 'car',
    key: 'plateNumber',
    render: (car: CarDto) => <Text strong>{car.plateNumber}</Text>,
  },
  {
    title: t('Start date'),
    key: 'begins',
    dataIndex: 'begins',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="startDateTime" {...props} />,
  },
  {
    title: t('End date'),
    key: 'ends',
    dataIndex: 'ends',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="endDateTime" {...props} />,
  },
  {
    title: t('Customer'),
    key: 'customer',
    dataIndex: 'customer',
    sorter: true,
    render: (customer: CustomerDto) => (
      <Text strong>
        {customer.firstName} {customer.lastName}
      </Text>
    ),
  },
];
